<template>
  <div class="message_main">
    <SettingSlider pageName="message" />
    <div class="container">
      <div class="status">
        <div class="all" :class="all ? 'active' : 'inactive'" @click="getAllMessage">
          全部（{{ allCount }}）
        </div>
        <div class="unRead" :class="all ? 'inactive' : 'active'" @click="filterUnread">
          未读（{{ unreadCount }}）
        </div>
      </div>

      <div class="list">
        <div
          class="item"
          v-for="item in messages"
          :key="item.id"
          @click="goMessage(item)"
        >
          <div class="message_title">动态</div>
          <div class="isRead" v-show="showIsRead(item)">NEW</div>
          <div class="item_content">
            {{ getUnit(item) }} 指标要求：{{ getRequired(item) }}
          </div>
          <div class="time">通知时间：{{ getTime(item) }}</div>
        </div>
      </div>
      <div class="page">
        <a-pagination
          :current="current"
          :total="allCount"
          @change="onChange"
          class="pagination"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SettingSlider from "../../components/SettingSlider.vue";
import server from "../../interface/message";
import storeUtil from "../../utils/storeUtil";

export default {
  mounted() {
    this.getAllMessage();
    // this.getUnreadMessage();
    this.getUserCode();
  },
  components: {
    SettingSlider,
  },
  computed: {},
  data() {
    return {
      messages: [],
      unreadCount: "",
      allCount: 0,
      current: 1,
      all: true,
      userCode: "",
    };
  },
  methods: {
    // 筛选出未读数据
    filterUnread() {
      server
        .getAllMessage({
          pageIndex: this.current,
          pageSize: 100,
          noRead: true,
        })
        .then((res) => {
          this.all = false;
          this.unreadCount = res.count;
          this.messages = res.indexPointReadEntityResultList;
        });
    },
    //筛选出所有的数据
    getAllMessage() {
      server
        .getAllMessage({
          pageIndex: this.current,
          pageSize: 10,
        })
        .then((res) => {
          this.all = true;
          this.allCount = res.count;
          this.messages = res.indexPointReadEntityResultList;
        });
    },
    getUnreadMessage() {
      server.getUnreadMessage().then((res) => {
        this.unreadCount = res;
      });
    },
    showIsRead(item) {
      var userCode = storeUtil.getUserInfo().roleCode;
      if (userCode == "unit" && !item.indexPointReadEntity.uHaveRead) {
        return true;
      } else if (userCode == "primaryReview" && !item.indexPointReadEntity.pHaveRead) {
        return true;
      } else if (userCode == "finalReview" && !item.indexPointReadEntity.fHaveRead) {
        return true;
      } else if (userCode == "sysAdmin" && !item.indexPointReadEntity.sHaveRead) {
        return true;
      } else {
        return false;
      }
    },
    getUnit(item) {
      if (item.userEntity) {
        return item.userEntity.account;
      } else {
        return "";
      }
    },
    getStatus(item) {
      console.log(item);
      return "";
    },
    getRequired(item) {
      if (item.indexPointEntity) {
        return item.indexPointEntity.require;
      } else {
        return "";
      }
    },
    getTime(item) {
      if (item.indexPointEntity) {
        return item.indexPointEntity.createTime;
      } else {
        return "";
      }
    },

    onChange(value) {
      this.current = value;
      this.getAllMessage();
    },

    getUserCode() {
      this.userCode = storeUtil.getUserInfo().roleCode;
    },

    goMessage(item) {
      console.log(item);
      server
        .getMessageDetails({
          id: item.indexPointReadEntity.id,
        })
        .then((response) => {
          console.log(response);
          if (this.userCode == "unit") {
            this.$router.push("/project/taskList");
          } else {
            this.$router.push("/project/review");
          }
        });
    },
  },
};
</script>

<style lang="less" scope>
.message_main {
  background-color: #f6f9fc;
  width: 100%;
  display: flex;
  .container {
    overflow: auto;
    position: absolute;
    bottom: 40px;
    right: 40px;
    left: 310px;
    top: 40px;
    padding: 25px 50px;
    background-color: white;
    .status {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #666666;
      opacity: 1;
      .all,
      .unRead {
        cursor: pointer;
        display: inline-block;
      }
      .unRead {
        margin-left: 30px;
      }
      .active {
        color: #4265ed;
      }
      .inactive {
        color: #666666;
      }
    }
    .status::after {
      content: "";
      background-color: #ededed;
      display: block;
      height: 1px;
      width: 100%;
      margin-top: 25px;
    }
    .list {
      overflow-y: scroll;
      .item {
        display: flex;
        justify-content: space-around;
        align-items: center;
        line-height: 60px;
        font-size: 20px;
        font-weight: 400;
        color: #333333;
        .message_title,
        .isRead,
        .item_content,
        .time {
          flex: 1;
          vertical-align: middle;
          display: inline-block;
        }
        .item_content {
          flex: 9;
          color: #4265ee;
          margin-left: 20px;
          vertical-align: middle;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 950px;
        }
        .time {
          flex: 4;
          text-align: right;
          margin-right: 5px;
        }
        .isRead {
          flex: 0.5;
          background: #ed4242;
          opacity: 1;
          font-size: 12px;
          color: white;
          padding: 0px 4px;
          margin: 0px 0px 0px 35px;
          line-height: 20px;
          height: 20px;
        }
        .item::after {
          content: "";
          background-color: #ededed;
          display: block;
          height: 1px;
          width: 100%;
        }
      }
    }
    .page {
      padding: 20px;
      float: right;
      .pagination {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
